import { initNavigation } from "./modules/navigation.js";
import { initCarousels } from "./modules/carousel.js";
import { initRealisations } from "./modules/realisations.js";
import { initNewsLoadMore } from "./modules/news.js";

function init() {
	initNavigation();
	initCarousels();
	initRealisations();
	initNewsLoadMore();
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init, { once: true });
} else {
	init();
}
